import { useQuery } from '@tanstack/react-query';
import { range } from 'lodash';
import { Stack, Typography } from '@mui/material';
import { ViewAllPartsButton } from '@qb/frontend/components/OmniSearch/_components/ViewAllPartsButton';
import { usePartsAutocompleteRequest } from '@qb/frontend/components/OmniSearch/_hooks/usePartsAutocompleteRequest';
import { PartCardHorizontal, PartCardHorizontalSkeleton } from '@qb/frontend/components/PartCards/PartCardHorizontal';
import { TenantAliasProps } from '@qb/frontend/types/tenantAlias.types';
import { spsClientQueries } from '@qb/httpRequest/spsClientQueries';
import { isNullableOrEmptyArray } from '@/shared/types/util/TypeGuards';
import { NoPartResults } from './NoPartResults';
type PartQueryProps = TenantAliasProps & {
  query: string;
};
export const PartQuery = ({
  query,
  tenantAlias
}: PartQueryProps) => {
  const {
    arePartsLoading,
    parts
  } = usePartsAutocompleteRequest(query, tenantAlias);
  const {
    data: tenantConfig
  } = useQuery({
    ...spsClientQueries.app.tenantConfig(tenantAlias)
  });
  const title = <Typography variant="h6" sx={{
    mb: 2,
    color: 'text.secondary'
  }}>
      Parts
    </Typography>;
  if (arePartsLoading) {
    return <>
        {title}
        <Stack spacing={1}>
          {range(4).map(index => <PartCardHorizontalSkeleton key={index} />)}
        </Stack>
      </>;
  }
  if (!tenantConfig) {
    return null;
  }
  if (isNullableOrEmptyArray(parts)) {
    return <NoPartResults tenantAlias={tenantAlias} />;
  }
  return <>
      {title}
      {parts.map(part => <PartCardHorizontal key={part.id} part={part} tenantConfig={tenantConfig} />)}
      <ViewAllPartsButton query={query} data-sentry-element="ViewAllPartsButton" data-sentry-source-file="PartQuery.tsx" />
    </>;
};